/**
 * Icon Mapper Utility
 * Maps feature IDs to Lucide React icons
 */

import {
  BedDouble,
  Users,
  Sparkles,
  BrainCircuit,
  Coins,
  CreditCard,
  Split,
  Receipt,
  Shield
} from 'lucide-react';

/**
 * Map of feature IDs to icon components
 */
export const ICON_MAP = {
  // Core
  'pms': BedDouble,
  'staff_management': Users,
  
  // AI Agents
  'ai_bitsy': Sparkles,
  'ai_marina': Users,
  'ai_sage': BrainCircuit,
  
  // Token Economy
  'hermes': Coins,
  
  // Web3
  'crypto_payments': CreditCard,
  'splits_router': Split,
  'nft_receipts': Receipt,
  'sbt_identity': Shield
};

/**
 * Get icon component for a feature ID
 * @param {string} featureId - Feature ID (e.g., 'ai_bitsy')
 * @returns {Component} - Lucide icon component
 */
export function getIcon(featureId) {
  return ICON_MAP[featureId] || BedDouble; // Default fallback
}
